<template>
  <div class="contact-info-block">
    <i :class="`contact-info-block__icon ${iconClass}`"></i>
    <div class="contact-info-block__details">
      <div class="centering-helper">
        <span v-if="phone">
          Puhelin:
          <a v-if="phone" :href="`tel:${phone}`" class="basic-link-grey">{{ phone }}</a>
        </span>
        <span v-if="mobile">
          Matkapuhelin:
          <a v-if="mobile" :href="`tel:${mobile}`" class="basic-link-grey">{{ mobile }}</a>
        </span>
        <span v-if="email">
          <span v-if="email">{{ email }}</span>
        </span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  phone?: string;
  mobile?: string;
  email?: string;
  iconClass?: string;
}>();
</script>
